<template>
<div class="home">
<section class="hero is-mobile is-large is-prime is-bold" v-cloak>
  <div class="auto">
    <div class="container">
      <h1 class="title is-2 welcome">
        {{ welcomeMessage }}
      </h1>
      <a href="#" v-scroll-to="{ el:'#intro', duration: 300, easing: 'ease-in-out', offset: -40 }">
      <img class="logo" :src="'../../../static/logos/ooshzonelogo.png'" alt="OOSH Zone Australia">
      </a>
        <!-- <i class="fas fa-3x fa-arrow-down"></i> -->
    </div>
  </div>
</section>
<section id="intro" >
<div class="container">
        <h1 class="title is-1 tit">OOSH Zone Australia</h1>
        <p class="subtitle is-4 sub">Outside of School Hours Care at St Gregory’s College Junior School, Gregory Hills and Mary Immaculate Parish Primary School, Eagle Vale</p>
        <div class="content">
          <div class="columns">
          <div class="column">
            <div class="about">
  <article class="tile box is-child notification is-orange">
<p class="subtitle is-5">OOSH Zone Australia provides reliable, child focused out of school hour’s care that is accessible to all families within the School community. We strive to maintain high quality standards of service in a welcoming, caring, friendly and stimulating environment.</p>
  </article></div></div>
          <!-- <div class="column">
            <div class="about">
  <article class="tile box is-child notification is-orange">
<p class="subtitle is-5"> We strive to maintain high quality standards of service in a welcoming, caring, friendly and stimulating environment.</p>
  </article>  </div> </div> -->
</div>

<div class="accred">
                <div class="columns">
    <div v-show="school === 'stjustins'" class="column">
           <div class="margin-auto myTime">
      <img  :src="'../../../static/logos/MeetingNQS.png'" alt="My Time Our Place" width="auto">

           </div></div>
              <div class="column">
           <div class="margin-auto myTime two">
      <img :src="'../../../static/logos/MyTimeOurPlace.png'" alt="My Time Our Place" width="auto">
           </div></div>
           </div>
      </div>

                <div class="columns">
    <div class="column">
<p class="menu-label">
 OOSH Zone provides:
</p>
<ul class="menu-list">
  <li>
    <router-link to="/about">
      Before School Care
    </router-link>
  </li>
  <li>
    <router-link to="/about">
      After School Care
    </router-link>
  </li>
  <li>
    <router-link to="/about">
      Vacation Care
    </router-link>
  </li>
  <li>
    <router-link to="/about">
      Pupil Free Days
    </router-link>
  </li>
</ul>
          </div></div></div>
<!-- <div class="more-info">
  <div class="columns">
  <div class="column">
        <router-link class="button navbar-item is-dark" to="/about">
        More Info
        </router-link>
        </div>
        <div class="column">
        <router-link class="button navbar-item is-dark" to="/documents">
        Important Documents
        </router-link>
        </div>
        <div class="column">
        <router-link class="button navbar-item is-dark" to="/gallery">
        Gallery
        </router-link>
        </div>
        <div class="column">
        <router-link class="button navbar-item is-dark" to="/contact">
        Contact
        </router-link>
        </div>
        </div>
</div> -->
</div>
</section>
<section class="photos"  v-cloak>
 <div class="container">
  <article class="tile box is-child notification is-orange">
    <Swiper />
  </article>
<!-- <div class="container">
  <div class="tile is-ancestor pad0">
  <div class="tile is-parent pad0">
    <article class="tile is-child notification is-link">
          <p class="title">Some of the team, some of the fun</p>
        <div class="content">
          <Swiper/>
        </div>
    </article>
  </div>
</div>
</div> -->
<!-- <div class="tile is-ancestor">
  <div class="tile is-vertical is-8">
    <div class="tile">
      <div class="tile is-parent is-vertical">
        <article class="tile is-child notification is-primary">
          <img src="../../../static/photos/land4.jpg">
        </article>
        <article class="tile is-child notification is-warning">
          <img src="../../../static/photos/land1.jpg">
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification is-info">
          <img src="../../../static/photos/port1.jpg">
        </article>
      </div>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child notification is-danger">
    <img src="../../../static/photos/land3.jpg">
      </article>
    </div>
  </div>
  <div class="tile is-parent is-vertical">
    <article class="tile is-child notification is-success">
    <img src="../../../static/photos/port3.jpg">
    </article>
     <article class="tile is-child notification is-warning">
    <img src="../../../static/photos/port4.jpg">
        </article>
  </div>
      </div>
       -->
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from './Swiper'

export default {
  name: 'Home',
  props: ['school'],
  data () {
    return {
      welcomeMessage: 'Welcome to'
    }
  },
  components: {
    Swiper
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  width: 100vw;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #111;
}
.home {
  /* padding-top: 100px; */
  background: #fff;
}
.hero {
  height: calc(100vh - 60px);
}
.hero-body {
  margin-top: -80px;
}
@media screen and (max-width: 796px) {
  .hero-body {
    margin-top: 0;
    padding-top: 45%;
  }
}

.hero.is-prime {
  background-image: linear-gradient(141deg, #fff 0, #fff 11%, #e67e22 100%);
}
img {
  width: 480px;
}
section.photos {
  margin: 0 auto 0 auto;
  padding-bottom: 80px;
}
.photos h1 {
  color: #fff;
  padding: 20px;
}
.photos .tile {
  margin: auto !important;
}
#intro {
  margin-top: 80px;
  color: #111;
  margin-bottom: 80px;
}
p {
  color: #111;
}
.more-info {
  margin: 40px 0;
}
.pad0 {
  padding-top: 0 !important;
}

.logo {
  height: auto;
  width: 260px;
}
.tit {
  border-bottom: 3px solid #e67e22;
  padding: 10px;
}
.sub {
  padding: 20px;
}
.about {
  padding: 20px 60px;
}

@media screen and (max-width: 480px) {
  .about {
    padding: 0;
  }
}

.is-orange {
  padding: 20px;
  background: #2d3436;
  color: #e67e22;
}
.menu-label {
  font-size: 150%;
}
.menu-list li {
  padding: 10px;
  border: 2px solid #e67e22;
  border-radius: 20px;
  font-weight: 500;
}
.box {
  padding: 40px 40px;
}
.welcome {
  margin-bottom: 0.5rem;
}
/* .column {
  padding-right: 0;
} */
.content ul {
    margin-left: 0;
    margin-top: 0;
}
.content ul li {
  width: 180px;
}
.columns {
  margin: 0;
}

.photos article {
  border-radius: 0;
}
.menu-list a {
  padding: 0;
}
.menu-list a:hover {
  background: transparent;
}
.auto {
  margin: auto;
}
[v-cloak] {
  display: none;
}
.myTime img {
  width: 240px;
  height: auto;
  margin: 0 auto;
  vertical-align: middle;
  /* margin-right: 20px; */
}
@media screen and (min-width: 500px) {
  .myTime img {
    /* margin-bottom: 60px; */
    height: auto;
    width: 200px;
  }
}

@media screen and (min-width: 500px) {
  .myTime.two img{
    /* margin-bottom: 60px; */
    height: 180px;
    width: auto;
  }
}

.margin-auto {
  margin: 0 auto;
  padding: 20px;
  vertical-align: middle;
}
.accred {
  margin: 40px auto 60px auto;
}
.accred .columns {
  display: flex;
  justify-content: center;
  align-items: center;
}
 @media screen and (max-width: 500px) {
  .accred .columns {
    display: block;
  }
  .myTime img {
    /* margin-bottom: 60px; */
    height: auto;
    width: 190px;
  }
  .myTime.two img{
    /* margin-bottom: 60px; */
    height: 180px;
    width: auto;
  }
  .accred .columns .column:first-child {
    margin-bottom: 40px;
  }
}
.hide {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue